import React from "react";
import "./src/styles/global.css";

import { Toaster } from "sonner";

export const wrapRootElement = ({ element }) => {
  return (
    <>
      <Toaster position="top-right" richColors />
      {element}
    </>
  );
};
